import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {TextTranslateService} from '../../../../provider/text-translate.service';
import {TextTranslateWithLocaleModel} from '../../../models/textTranslateWithLocale.model';
import {TranslateModel} from '../../../../core/_base/layout/models/translate.model';
import {TranslationService} from '../../../../provider/translation.service';
import {AppHotelModel} from '../../../models/app-hotel.model';
import {AppHotelService} from '../../../../provider/app-hotel.service';
import {UserService} from '../../../../provider/user.service';

@Component({
  selector: 'c-language-translate',
  templateUrl: './language-translate.popup.html',
  styleUrls: ['./language-translate.popup.scss']
})
export class LanguageTranslatePopup implements OnInit {
  hotelLanguages: string[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public tra: TranslationService,
              private dialogRef: MatDialogRef<LanguageTranslatePopup>,
              private googleTranslate: TextTranslateService,
              private appHotelService: AppHotelService,
              private userService: UserService) {
  }

  ngOnInit() {
    this.appHotelService.getHotelInfo(this.userService.record_change$.getValue().app_hotel_id).subscribe(
      (hotel: AppHotelModel) => {
        this.hotelLanguages = hotel.languages.split(',');
      },
      err => console.error(err)
    );
  }

  close() {
    this.dialogRef.close(this.data);
  }

  translate(Data: any, key: string, target_location: string) {
    const baseData = Data.baseData;

    let translateModel: TranslateModel;
    translateModel = new TranslateModel();

    if (baseData[key] == '') {
      translateModel = new TranslateModel();
    } else {
      translateModel = JSON.parse(baseData[key]);
    }


    const engSourceText: string[] = [];
    engSourceText.push(translateModel.en);
    // console.log('Base Data : *', translateModel.en, '***');
    this.googleTranslate.translateWithLocale(target_location, engSourceText).subscribe(
      (data: TextTranslateWithLocaleModel) => {
        switch (target_location) {
          case 'fr':
            translateModel.fr = data.eng_source_descriptions[0];
            Data.ML.fr = data.eng_source_descriptions[0];
            break;
          case 'de':
            translateModel.de = data.eng_source_descriptions[0];
            Data.ML.de = data.eng_source_descriptions[0];
            break;
          case 'ru':
            translateModel.ru = data.eng_source_descriptions[0];
            Data.ML.ru = data.eng_source_descriptions[0];
            break;
          case 'ar':
            translateModel.ar = data.eng_source_descriptions[0];
            Data.ML.ar = data.eng_source_descriptions[0];
            break;
          case 'fa':
            translateModel.fa = data.eng_source_descriptions[0];
            Data.ML.fa = data.eng_source_descriptions[0];
            break;
          case 'es':
            translateModel.es = data.eng_source_descriptions[0];
            Data.ML.es = data.eng_source_descriptions[0];
            break;
        }
        baseData[key] = JSON.stringify(translateModel);
        this.data.baseData = baseData;
      },
      (err) => console.log(err),
    );

  }

  languageControl(lang: string): boolean {
    const data = this.hotelLanguages.find(x => x == lang);
    return data != undefined;
  }
}
